/**
 * 报表模版管理
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XSelect, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import model from '@/reducers/report/reporttemplate/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { TableActionType as ta } from '@/util/enum';
import { message } from 'antd';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {

    state = {
        templateName: undefined,
        status: {},
        pageNum: 1,
        pageSize: 10,
    }

    componentDidMount() {
        this.props.getStateList({ enumName: 'StateEnum' });
        this.props.setBreadcrumbPaths(this.props.match);
    }

    // 查询
    _searchHandle = (useCache) => {
        const { templateName, status, pageNum, pageSize } = this.state;
        this.searchCache = {
            templateName,
            state: status.code,

            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getTableSource(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 重置
    _resetHandle = () => {
        this.setState({ templateName: undefined, status: {}, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        switch (type) {
            case ta.detail:
                this.props.history.push({ pathname: `/home/report/reporttemplate/detail/${key}` });
                break;
            case ta.link:
                if (item.templateUrl) {
                    const regular = /(http|https):\/\/([\w.]+\/?)\S*/;
                    regular.test(item.templateUrl)
                        ? (location.href = item.templateUrl, message.success('导出成功'))
                        : message.warning('路径无效');
                } else {
                    message.warning('暂无数据');
                }
                break;
        }
    }

    render() {
        const { templateName, status } = this.state;
        let { tableSource, stateList } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 200 }}
                                label='模版名称'
                                placeholder='请输入'
                                value={templateName}
                                bindThis={this}
                                bindName='templateName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                selectStyle={{ width: '150px' }}
                                label='状态'
                                placeholder='请选择'
                                renderData={stateList}
                                dataIndex='value'
                                keyIndex='code'
                                value={status.value}
                                bindThis={this}
                                bindName='status'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableList
                        renderData={tableSource}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,
    setBreadcrumbPaths: PropTypes.func,

    getTableSource: PropTypes.func,
    tableSource: PropTypes.object,

    getStateList: PropTypes.func,
    stateList: PropTypes.array
};
const mapStateToProps = (state) => ({
    stateList: state.reporttemplate.stateList,
    tableSource: state.reporttemplate.tableSource,
});

export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);